import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";
import eventBus from "../../../event-bus/eventBus";

const cancelSubscription = {
    namespaced: true,
    state: {
        isShowModalCancelSubscription: false,
        isSubscriptionCanceling: false,
    },
    mutations: {
        UPDATE_VISIBLE_MODAL_CANCEL_SUBSCRIPTION(state, value) {
            state.isShowModalCancelSubscription = value;
        },
        CANCEL_SUBSCRIPTION_SUCCESS(state, response) {
            let dataReceive = {
                title: response.data.message,
                message: response.data.data.textInfo
            };
            state.isSubscriptionCanceling = false;
            eventBus.$emit("cancelSubscriptionSuccess", dataReceive);
        },
        CANCEL_SUBSCRIPTION_FAILURE(state, error) {
            console.log(error);
        }
    },
    actions: {
        cancelSubscriptionRequest: function({ dispatch, state }) {
            let promise = sendRequest("post", config.baseURLApi + "/user-subscriptions/cancel", {}, {}, true);
            state.isSubscriptionCanceling = true;
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successCancelSubscription", result[1]);
                } else {
                    dispatch("failureCancelSubscription", result[1]);
                }
            })
        },
        successCancelSubscription: function({ commit }, response) {
            commit("CANCEL_SUBSCRIPTION_SUCCESS", response);
        },
        failureCancelSubscription: function({ commit }, error) {
            commit("CANCEL_SUBSCRIPTION_FAILURE", error);
        },
        updateVisibleModalCancelSubscription: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL_CANCEL_SUBSCRIPTION", value);
        },
    }
}

export default cancelSubscription;